const styles = (theme) => ({
	container: {
		width: "100%",
		maxWidth: "100%",
		display: "flex",
		flexDirection: "column",
		gap: "1rem",
		position: "relative",
	},

	paper: {
		padding: "16px",
		display: "flex",
		flexDirection: "row",
		gap: 1,
		justifyContent: "space-between",
		minHeight: "200px",
		width: "100%",
		maxWidth: "100%",
		borderRadius: "16px",
	},
	paperDatagrid: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		position: "relative",
		overflow: "hidden",
	},
	linearProgress: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		zIndex: 1,
	},
	titleDatagrid: {
		color: theme.palette.text.primary,
		fontWeight: 500,
		padding: "10px 20px",
		textAlign: "left",
	},
	cardTitle: {
		fontWeight: 500,
		fontSize: "1rem",
	},
	cardText: {
		fontWeight: 500,
		fontSize: "24px",
		"@media (max-width: 600px)": {
			fontSize: "20px",
		},
		textWrap: "nowrap",
	},
	cardSubText: {
		fontWeight: 500,
		fontSize: "16px",
		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	cardSubTextPie: {
		fontWeight: 500,
		fontSize: "12px",
		width: "100px",
		textWrap: "wrap",
		textAlign: "start",
		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	cardSubText: {
		fontWeight: 500,
		fontSize: "16px",

		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	littlePaper: {
		width: "100%",
		height: "180px",
		padding: "16px",
		display: "flex",
		flexDirection: "column",
		gap: "1rem",
		justifyContent: "center",
		gap: 1,
	},
	littleChart: {
		height: "50px",
		width: "",
	},
	boxPieChart: {
		display: "flex",
		width: "100%",
		height: "100%",
		position: "relative",
	},

	// estilos do modal de histórico de ping
	pingModalDialog: {
		borderRadius: "16px",
		overflow: "hidden",
	},
	pingModalHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "16px 20px 8px",
		gap: 1,
	},
	pingModalHeaderIcon: {
		display: "flex",
		alignItems: "center",
		gap: 1,
	},
	pingModalTitle: {
		fontWeight: 600,
		fontSize: "1.1rem",
	},
	pingModalContent: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		padding: "8px 20px 20px",
	},
});

export default styles;
